<template>
  <v-dialog v-model="dialog" persistent scrollable content-class="cookies-dialog" :max-width="screenType === 'desktop' ? '70%' : '90%'">
    <template v-slot:activator="{ on, attrs }">
      <span v-if="activator === 'know-more'" class="know-more" v-bind="attrs" v-on="on">Saber mais</span>
      <p v-if="activator === 'cookies'" v-bind="attrs" v-on="on">Cookies e política de privacidade</p>
    </template>
    <v-card class="cookies-dialog-container">
      <v-card-text>
        <div class="pb-5">
          <p class="mt-5 text-center">
            <strong> POLÍTICA DE COOKIES </strong> <br />
          </p>

          <p class="my-2">
            Prezado usuário, norteados pelo respeito à sua privacidade e empenhados em tratar as suas informações pessoais de acordo com a lei vigente, esta Política de Cookies detalha como utilizamos cookies e tecnologias similares para tratar suas informações pessoais fornecidas quando você visita nosso site.
          </p>

          <p>
            <strong>Para usuários localizados no território nacional brasileiro:</strong> <br />
            Esta política de cookies será tratada de acordo com a Lei Geral de Proteção de Dados Pessoais, número 13.709 / 2018 do Brasil (LGPD). <br />
            Para obter mais informações sobre como usamos, armazenamos, compartilhamos e tratamos os dados pessoais que obtemos através ou em conexão com o uso do nosso Site, visite nossa Política de Privacidade. <br />
            Quando você acessar nosso site pela primeira vez dentro do território nacional brasileiro, em concordância com Art. 3º da LGPD, você receberá uma mensagem aconselhando-o que cookies e tecnologias semelhantes estão em uso. Ao clicar em "Utilizar apenas os cookies necessários" ou em "Permitir todos os cookies", significa que você compreendeu e concordou com o uso dessas tecnologias conforme descrito nesta Política de Cookies.
          </p>

          <p class="mt-2">2. <strong>O que são cookies?</strong> <br /></p>

          <p class="ml-5 my-2">
            Cookies são arquivos de texto contendo pequenos pedaços de dados que são armazenados em seu computador ou dispositivo móvel sempre que você acessa
            um site. São úteis por permitirem que os sites funcionem, ou trabalhem de forma mais eficiente, bem como para fornecer informações aos proprietários
            do site. Os cookies melhoram a experiência do usuário, permitindo que os sites os leiam e escrevam, possibilitando que eles reconheçam os visitantes
            e lembrando as informações importantes que tornam o uso do site mais conveniente para o visitante.
          </p>

          <p>
            Os cookies definidos por um proprietário de site são chamados de "cookies proprietários". Cookies definidos por partes que não sejam o proprietário do site são chamados de "cookies de terceiros". Cookies de terceiros permitem que recursos ou funcionalidades de terceiros sejam fornecidos no site ou através do Site (por exemplo, análise).
          </p>

          <p class="mt-2">3. <strong>Quais Cookies usamos?</strong> <br /></p>

          <p class="ml-5 my-2">Podemos usar os seguintes tipos de Cookies para tornar o site fácil de usar:</p>

          <p>
            <strong>Cookies Necessários:</strong> <br />
            Os cookies necessários ajudam a tornar um site utilizável, permitindo funções básicas como navegação de página e acesso para proteger áreas do site.
            O site pode não funcionar corretamente sem esses cookies.
          </p>

          <div class="table-container mt-2 mb-5">
            <table border="1">
              <tbody>
                <tr>
                  <th>Cookie</th>
                  <th>Fornecedor</th>
                  <th>Finalidade</th>
                  <th>Validade</th>
                  <th>Tipo</th>
                </tr>
                <tr>
                  <td>__cfduid</td>
                  <td>cloudflare.com</td>
                  <td>Este cookie é usado pela rede de conteúdos, Cloudflare, para identificar tráfico online confiável</td>
                  <td>30 dias</td>
                  <td>HTTP</td>
                </tr>
                <tr>
                  <td>test_cookie</td>
                  <td>doubleclick.net</td>
                  <td>Este cookie é usado para verificar se o navegador do usuário tem suporte para os cookies</td>
                  <td>1 dia</td>
                  <td>HTTP</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p>
            <strong>Cookies de Estatística:</strong> <br />
            Também conhecidos como cookies de análise, esses cookies podem ser usados para coletar informações sobre o seu uso do Site e tornar o Site mais fácil de usar. O uso dos cookies analíticos inclui, mas não se limita a distinguir usuários e entender padrões gerais de uso do Site. Usamos essas informações de forma agregada para melhorar a forma como nosso Site funciona. Importante informar que a coleta e o relatório da informação é feita de forma anônima.
          </p>

          <div class="table-container mt-2 mb-5">
            <table border="1">
              <tbody>
                <tr>
                  <th>Cookie</th>
                  <th>Fornecedor</th>
                  <th>Finalidade</th>
                  <th>Validade</th>
                  <th>Tipo</th>
                </tr>
                <tr>
                  <td>_ga</td>
                  <td>mercafacil.com</td>
                  <td>Registra um ID único que é usado para gerar dados estatísticos sobre como o visitante usa o website</td>
                  <td>2 anos</td>
                  <td>HTTP</td>
                </tr>
                <tr>
                  <td>_gat</td>
                  <td>mercafacil.com</td>
                  <td>Usado pelo Google Analytics para limitar a taxa de solicitação</td>
                  <td>1 dia</td>
                  <td>HTTP</td>
                </tr>
                <tr>
                  <td>_gid</td>
                  <td>mercafacil.com</td>
                  <td>Registra um ID exclusivo que é usado para gerar dados estatísticos sobre como o visitante usa o site</td>
                  <td>1 dia</td>
                  <td>HTTP</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p>
            <strong>Cookies de Marketing:</strong> <br />
            Essa categoria de cookies é utilizada para localizar visitantes entre websites. A intenção é exibir anúncios que sejam relevantes e envolventes para o usuário individual e, portanto, mais valioso para editores e anunciantes terceirizados.
          </p>

          <div class="table-container mt-2 mb-5">
            <table border="1">
              <tbody>
                <tr>
                  <th>Cookie</th>
                  <th>Fornecedor</th>
                  <th>Finalidade</th>
                  <th>Validade</th>
                  <th>Tipo</th>
                </tr>
                <tr>
                  <td>_gcl_au</td>
                  <td>mercafacil.com</td>
                  <td>Usado pelo Google AdSense para experimentar a eficiência de publicidade em sites usando seus Serviços</td>
                  <td>3 meses</td>
                  <td>HTTP</td>
                </tr>
                <tr>
                  <td>IDE</td>
                  <td>doubleclick.net</td>
                  <td>
                    Usado pelo Google DoubleClick para registrar e relatar as ações do usuário do site após visualizar ou clicar em anúncios do anunciante com o
                    propósito de medir a eficácia de um anúncio e de apresentar anúncios direcionados ao usuário
                  </td>
                  <td>1 ano</td>
                  <td>HTTP</td>
                </tr>
                <tr>
                  <td>pagead/1p-user-list/#</td>
                  <td>google.com</td>
                  <td>
                    Monitora se o usuário tem demonstrado interesse em produtos ou eventos específicos em múltiplos sites, e detecta como o usuário navega entre
                    os sites. Este cookie é usado para medir os esforços despendidos em anúncios e facilita o pagamento de taxas por indicação entre sites
                  </td>
                  <td>Por sessão</td>
                  <td>Pixel</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p>
            Esses cookies podem ser excluídos ou bloqueados ajustando as configurações do seu navegador (consulte a Seção 4, Como você pode controlar cookies,
            abaixo). <br />
            Alternativamente, siga os links abaixo para revogar seu consentimento ao uso de cookies: <br />
            Google Analytics: <a class="link" href="https://tools.google.com/dlpage/gaoptout" target="_blank">https://tools.google.com/dlpage/gaoptout</a>
          </p>

          <p class="mt-2">4. <strong>Como você pode controlar cookies?</strong> <br /></p>

          <p class="ml-5 my-2">
            Você não precisa aceitar os cookies e o seu consentimento pode ser retirado a qualquer momento. Você tem o direito de decidir, de forma granular ou
            completa, se aceita ou rejeita o uso dos cookies. Por favor, note que cookies estritamente necessários não podem ser rejeitados, pois são
            estritamente necessários para lhe fornecer os serviços do nosso Site.
          </p>

          <p class="mb-2">
            Quando você acessar nosso site pela primeira vez dentro de território nacional brasileiro, em acordo com Art 3º da LGPD, você receberá uma mensagem
            indicando que cookies e tecnologias semelhantes estão em uso. Ao clicar em “Utilizar apenas os cookies necessários” ou em “Permitir todos os
            cookies”, significa que você entende e concorda com o uso dessas tecnologias, conforme descrito nesta Política de Cookies. <br />
            Usando nosso Banner de Consentimento de Cookies, você pode selecionar as categorias de cookies que você opta por aceitar ou rejeitar. O Banner de
            Consentimento de Cookie aparecerá imediatamente no primeiro acesso ao nosso Site na forma de um banner de notificação, e também a qualquer momento
            estará disponível ao final da página do Site. Você pode modificar ou revogar o consentimento à nossa Política de cookies diretamente a partir do
            nosso Website, ao clicar em “Configurações de cookies” ao fim da página. <br />
            Se você optar por não clicar em “Utilizar apenas os cookies necessários” ou em “Permitir todos os cookies”, ou não fechar a mensagem para rejeitar
            cookies, você ainda poderá usar o nosso Site, entretanto com algumas limitações de configurações na sua navegação. Você também pode se recusar a
            aceitar cookies deste Site a qualquer momento ativando a configuração em seu navegador que permite recusar cookies. <br />
            Siga os links abaixo para obter informações úteis para os navegadores mais populares:
          </p>

          <p>
            ✓ Apple Safari: <br />
            <a class="link" href="https://support.apple.com/en-us/HT201265" target="_blank">https://support.apple.com/en-us/HT201265</a>
          </p>

          <p>
            ✓ Google Chrome: <br />
            <a class="link" href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl" target="_blank"
              >https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl</a
            >
          </p>

          <p>
            ✓ Microsoft Edge: <br />
            <a class="link" href="https://support.microsoft.com/en-us/help/10607/microsoft-edge-view-delete-browser-history" target="_blank"
              >https://support.microsoft.com/en-us/help/10607/microsoft-edge-view-delete-browser-history</a
            >
          </p>

          <p>
            ✓ Microsoft Internet Explorer: <br />
            <a class="link" href="https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies" target="_blank"
              >https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies</a
            >
          </p>

          <p>
            ✓ Mozilla Firefox: <br />
            <a class="link" href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences" target="_blank"
              >https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences</a
            >
          </p>

          <p class="mt-2">5. <strong>Sobre alterações na Política de Cookies</strong></p>

          <p class="ml-5 my-2">
            Podemos atualizar esta Política de Cookies de tempos em tempos para refletir, por exemplo, alterações nos cookies que usamos ou por outras razões
            operacionais, legais ou regulamentares. Por favor, visite esta Política de Cookies regularmente para ficar informado sobre o uso de cookies e
            tecnologias relacionadas. Você também será contatado, via e-mail, quando alterações que impactem no seu consentimento forem realizadas, como
            expresso em algumas legislações nacionais.
          </p>

          <p>A data no topo deste documento quando a Política foi atualizada pela última vez.</p>
        </div>
      </v-card-text>
      <v-card-actions class="px-6 pt-3 modal-actions">
        <div>
          <v-checkbox
            v-model="checkbox"
            :hide-details="!checkbox"
            label="Permitir o uso de cookies de marketing"
            :color="getAssets.colors.form.buttonBackground"
          />
          <p v-if="!checkbox" class="mt-2 mb-0 revoked-message">
            Os cookies foram removidos! A partir do seu próximo acesso eles estarão desabilitados. Para que isso seja instantâneo, basta recarregar a página.
          </p>
        </div>

        <v-btn
          width="150"
          class="button-height"
          :block="isMobile"
          :color="getAssets.colors.form.buttonBackground"
          :style="{ color: getAssets.colors.form.buttonFont }"
          @click="close"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { screenTypeMixin } from '@/mixins/screen-type'
export default {
  mixins: [screenTypeMixin],
  props: {
    activator: {
      type: String,
      default: 'know-more'
    },
    acceptTerms: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog: false
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly
    },
    getAssets() {
      return this.$store.getters.GET_ASSETS
    },
    checkbox: {
      get() {
        return this.acceptTerms
      },
      set(value) {
        this.$emit('update:acceptTerms', value)
      }
    }
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        const pixelCookiePermission = localStorage.getItem('pixelCookiePermission') === 'true'
        const googleAnalyticsCookiePermission = localStorage.getItem('googleAnalyticsCookiePermission') === 'true'

        this.checkbox = pixelCookiePermission && googleAnalyticsCookiePermission
      }
    }
  },
  methods: {
    close() {
      this.$emit('close', this.checkbox)
      this.dialog = false
    }
  }
}
</script>

<style lang="scss">
$phone-size: 600px;
$tablet-size: 960px;

.cookies-dialog {
  &-container {
    padding: 35px 15px;

    & .revoked-message {
      color: #b3280d;
      font-size: 14px;
      max-width: 600px;
    }

    & .modal-actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    & p {
      font-size: 16px;
      text-align: left !important;
      color: #6b7580;
      line-height: 150%;
    }

    &-title {
      color: #4b525a;
      font-weight: 500;
      font-size: 22px;
    }

    & label {
      font-size: 14px !important;
      color: #6f6f6f !important;
    }
  }

  & .link {
    color: #0079f2;
    cursor: pointer;
    text-decoration: underline;
  }

  & .table-container {
    overflow-x: auto;
    & table {
      border: 1px solid grey;
      border-collapse: collapse;
      color: #6f6f6f;
      width: calc(100% - 2px);

      & td {
        padding: 10px;
      }

      & th {
        text-align: left;
        padding: 10px;
      }
    }
  }
}

@media screen and (max-width: $tablet-size) {
  .cookies-dialog {
    &-container {
      & .modal-actions {
        display: block;
        width: 100%;
      }

      & .v-btn {
        margin-top: 12px;
      }
    }
  }
}

@media screen and (max-width: $phone-size) {
  .cookies-dialog {
    &-container {
      & p {
        font-size: 14px;
      }

      &-title {
        font-size: 16px;
      }
    }
  }
}
</style>
